import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import Sidebar from "../component/layout_components/sidenav";
import Header from "../component/layout_components/header";
import  {Mainlaystyle} from "../styles/layout";
import { useTheme } from "@mui/material/styles";

const MainLayout = () => {
    const theme = useTheme();
    const classes = Mainlaystyle(theme);
    return (
        <Box sx={classes.rootBox}>
        
            <Sidebar />
            <Box sx={classes.componentDiv}>
                <Box sx={classes.HeaderDiv}>
                    <Header />
                </Box>

                <Box sx={classes.outletDiv}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    )
}

export default MainLayout